import { createContext, useContext } from 'react';
export const SectionBoundariesContext = /*#__PURE__*/createContext({
  index: -1,
  isBoxed: false,
  borderBottom: false,
  borderTop: false
});
export function useSectionBoundariesContext() {
  return useContext(SectionBoundariesContext);
}
export default SectionBoundariesContext.Provider;